import { Box, Typography } from '@mui/material'; // ✅ Don't forget to import Typography
import React, { useMemo } from 'react';
import ResponsiveNav from '../components/navigation/navigation';
import OrderHistoryTable from '../components/OrderHistoryTable/OrderHistoryTable';
// import GiftSubHero from '../components/SubHero/SubHero';
import MoreItems from '../components/MoreItems/MoreItems';
import { useGet } from '../hooks/useApi';
import { useNavigate } from 'react-router-dom';
import HistoryHeader from '../components/HistoryHead.erjsx/HistoryHeader';

const CoursesOrderHistory = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);  // Handle navigation back
  };

  const breadcrumbItems = [
    { label: 'Home', link: '/' },
    { label: 'Product Details', link: goBack },
    { label: 'Buy List', link: '/product/digital-courses/order-history' },
  ];

  const customerId = sessionStorage.getItem('userId');
  console.log(customerId);

  const { 
    data: courseOrderHistory, 
    error: courseOrderError, 
    isLoading: courseOrderLoading 
  } = useGet(customerId ? `/api/DigitalCourseOrders/order-history?userEmail=${customerId}` : null);

  const courseOrderItems = useMemo(() => courseOrderHistory?.data || [], [courseOrderHistory]);
  console.log(courseOrderItems);

  // const [openModal, setOpenModal] = useState(false);

  // ✅ Loading and Error handling here BEFORE return
  if (courseOrderLoading) {
    return <Typography>Loading...</Typography>;
  }

  if (courseOrderError) {
    return <Typography>Error loading your order history. Please try again later.</Typography>;
  }

 
  return (
    <Box>
      <ResponsiveNav breadcrumbItems={breadcrumbItems} searchValue="" onSearchChange={() => {}} searchPlaceholder="Search..." />
      <HistoryHeader />
      <OrderHistoryTable order_data={courseOrderItems} />
      <MoreItems title={`Gift ${'For Him'}`} />
    </Box>
  );
}

export default CoursesOrderHistory;
